var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Preferências dos grupos","p-read-link":"groupPreference.read.one","p-create-link":"groupPreference.create","p-name":"GroupsPreferences"}})}
var staticRenderFns = []

export { render, staticRenderFns }